import React, {useState} from 'react';
import PropTypes from 'prop-types';
import useDidMountEffect from "utils/useDidMountEffect";
import apiUser from "apiUser";
import Select from "componentsReusable/Select";
import useAfterUpdateEffect from "../../../utils/useAfterUpdateEffect";
import {useTecRmi} from "../../../contexts/TecRmiContext";

const ComponentsTypeIdSelect = props => {
  const { getApiPrimaryParams } = useTecRmi()
  const [value, setValue] = useState(props.value)
  const [componentsTypeId, setComponentsTypeId] = useState([])

  useAfterUpdateEffect(() => {
    if(value !== props.value){
      setValue(props.value)
    }
  }, [props.value])

  useAfterUpdateEffect(() => {
    props.onChange(value)
  }, [value])

  useDidMountEffect(() => {
    apiUser.tecRmi.diagnostics.componentsForType(getApiPrimaryParams())
      .then(res => {
        setComponentsTypeId(res.data)
        if(res.data.length === 1){
          setValue(res.data[0].ComponentTypeId)
        }
      })
  })

  const getOptions = () => {
    return componentsTypeId.map(componentTypeId => ({
      label: componentTypeId.ComponentTypeName,
      value: componentTypeId.ComponentTypeId,
    }))
  }

  if(componentsTypeId.length > 1){
    return <div className={props.className}>
      <Select
        placeholder={'Wybierz silnik...'}
        onChange={setValue}
        value={value}
        options={getOptions()}
      />
    </div>
  }

  return null
};

ComponentsTypeIdSelect.defaultProps = {
  className: '',
};

ComponentsTypeIdSelect.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default ComponentsTypeIdSelect;